import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-icon-lines',
  templateUrl: './icon-lines.component.html',
  styleUrls: ['./icon-lines.component.scss']
})
export class IconLinesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
